import Routestree from './components/route/Routestree'; //Get All Routes
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./common.css";
import "./style.css";
import { AnimatePresence } from "framer-motion";
import { BrowserRouter as Router } from 'react-router-dom';
import Maintenance from "../src/components/signup/Maintenance";

function App() {
  const maintenance = true;
  return (
    <>
      {!maintenance ? (
        <Maintenance />
      ) :
        <>
          <AnimatePresence>
            <Router >
              <div className="app">
                {/*Write Routes for */}
                <Routestree />
                {/*End here*/}
              </div>
            </Router>
          </AnimatePresence>
        </>
      }
    </>
  );
}

export default App;
